/* @jsx h */
import { defineComponent, h, PropType } from "vue";
import {
  TableSelector,
  type TableSelectorTable,
} from "@app/vue/components/Business/TableSelector";
import { useLocalization } from "@lemmonhq/uikit";

export interface TableSelectionPanelProps {
  tables: TableSelectorTable[];
  selectedIds: number[];
  onChange: (ids: number[]) => void;
  loading?: boolean;
  error?: string;
  onRetry?: () => void;
  availableCount?: number;
  totalCount?: number;
  selectionDisabled?: boolean;
}

export const TableSelectionPanel = defineComponent<TableSelectionPanelProps>({
  name: "TableSelectionPanel",
  props: {
    tables: {
      type: Array as PropType<TableSelectorTable[]>,
      required: true,
    },
    selectedIds: {
      type: Array as PropType<number[]>,
      required: true,
    },
    onChange: {
      type: Function as PropType<(ids: number[]) => void>,
      required: true,
    },
    loading: Boolean,
    error: String,
    onRetry: Function as PropType<() => void>,
    availableCount: Number,
    totalCount: Number,
    selectionDisabled: Boolean,
  },
  setup(props) {
    const { t } = useLocalization();

    return () => (
      <div class="space-y-3">
        <div class="flex items-center gap-2 mb-0.5">
          <h4 class="text-xs font-semibold text-accent uppercase tracking-wider">
            {t("reservations.form.assign_tables")}
          </h4>
          <span class="text-[10px] font-medium text-base-content px-1.5 py-0.5 rounded border border-base-content/10">
            {t("reservations.form.optional_badge")}
          </span>
        </div>

        <div class="space-y-3">
          <TableSelector
            tables={props.tables}
            selectedIds={props.selectedIds}
            onChange={props.onChange}
            loading={props.loading}
            error={props.error}
            onRetry={props.onRetry}
            emptyMessage={t("reservations.form.no_tables_configured")}
            selectionDisabled={props.selectionDisabled}
            simplified={true}
            showFloorPlanDividers={true}
          />
        </div>
      </div>
    );
  },
});
